module.exports = __webpack_public_path__ + "static/media/kiuas.dfc97a65.mp3";